import { render, staticRenderFns } from "./PagosFacturas.vue?vue&type=template&id=a4794f64&scoped=true"
import script from "./PagosFacturas.vue?vue&type=script&lang=js"
export * from "./PagosFacturas.vue?vue&type=script&lang=js"
import style0 from "./PagosFacturas.vue?vue&type=style&index=0&id=a4794f64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4794f64",
  null
  
)

export default component.exports